import { Link, useParams } from "react-router-dom";
import Breadcrumb from "@/components/base/Breadcrumb";
import LiveCard from "@/components/base/LiveCard";
import { liveItems } from "@/mocks/lives";
import { getLiveById, getRelatedLives } from "@/utils/live";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import PlayerArea from "./components/PlayerArea";
import LiveInfoBar from "./components/LiveInfoBar";
import DanmakuPanel from "./components/DanmakuPanel";

export default function LiveDetail() {
  const { id = "" } = useParams();
  const item = getLiveById(liveItems, id);
  const related = getRelatedLives(liveItems, id, 4);

  useDocumentTitle(
    item ? `【${item.streamer}】正在直播《${item.title}》 | 360直播` : "直播不存在 | 360直播",
    item ? `${item.streamer}在360直播带来《${item.title}》，属于${item.category}频道，支持高清在线观看与实时互动。` : undefined
  );

  if (!item) {
    return (
      <div className="mx-auto flex w-full max-w-[1440px] flex-col items-center px-4 py-24 text-center md:px-6">
        <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-background-100 text-foreground-500">
          <i className="ri-live-line text-3xl" />
        </span>
        <h1 className="mt-6 font-heading text-xl font-bold text-foreground-950">未找到该直播</h1>
        <p className="mt-3 max-w-md text-sm text-foreground-600">
          该直播可能已结束或链接有误，去看看其他正在进行的精彩直播吧。
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/channels"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-live-line" />
            浏览频道分类
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-500/60"
          >
            <i className="ri-home-4-line" />
            返回首页
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-auto w-full max-w-[1440px] px-4 py-8 md:px-6 md:py-12">
      <Breadcrumb
        items={[
          { label: "首页", to: "/" },
          { label: "频道分类", to: "/channels" },
          { label: item.title },
        ]}
      />

      <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-12">
        <div className="flex flex-col gap-6 lg:col-span-8">
          <PlayerArea item={item} />
          <LiveInfoBar item={item} />

          <div className="rounded-lg border border-background-200/60 bg-background-100 p-5">
            <h2 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
              <i className="ri-file-text-line text-primary-300" />
              直播简介
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">{item.description}</p>
            <div className="mt-4 flex flex-wrap gap-2">
              {item.tags.map((tag) => (
                <span
                  key={tag}
                  className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900"
                >
                  #{tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="lg:col-span-4">
          <DanmakuPanel />
        </div>
      </div>

      <section className="mt-10">
        <div className="mb-5 flex items-center justify-between">
          <h2 className="font-heading text-lg font-bold text-foreground-950 md:text-xl">相关直播推荐</h2>
          <Link
            to="/channels"
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-300 transition-colors hover:text-primary-200"
          >
            更多直播
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {related.map((rel) => (
            <LiveCard key={rel.id} item={rel} />
          ))}
        </div>
      </section>

      <div className="mt-10 flex flex-wrap items-center gap-3">
        <Link
          to="/channels"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-500/60"
        >
          <i className="ri-arrow-left-line" />
          返回频道分类
        </Link>
        <Link
          to="/"
          className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-500/60"
        >
          <i className="ri-home-4-line" />
          返回首页
        </Link>
      </div>
    </div>
  );
}